import React, { useState, useEffect } from "react";

import { Button } from "@mui/material";

import { PageStandard } from "components/admin/PageStandard";
import { useUserContext } from "contexts/UserContext";
import { LightingTypes } from "api/automationTypes";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  LightDetail,
  LightDetailItem,
  emptyLightDetail,
} from "components/forms/LightDetail";
import { createLighting, fetchLightingOptions } from "api/automation";
import { useSetError } from "contexts/ErrorContext";
import { CustomCodes, ErrorResponse } from "contexts/ErrorContextData";
import { DetailedSelector } from "components/admin/DetailedSelector";

export const CreateLighting = ({ history }) => {
  const { token, currentEnvironment } = useUserContext();
  const setError = useSetError();

  const [lampOptions, setLampOptions] = useState<LightingTypes[]>([]);
  const [lightsData, setLightsData] = useState<LightDetailItem[]>([
    { ...emptyLightDetail },
  ]);

  useEffect(() => {
    const getTypesList = async () => {
      try {
        const data = await fetchLightingOptions(token);
        setLampOptions(data || []);
      } catch (error) {
        // @ts-expect-error
        setError(error.response.data.error as ErrorResponse);
      }
    };
    getTypesList();
  }, [token, setError]);

  const handleSubmit = async () => {
    if (lightsData?.length && currentEnvironment?.id) {
      try {
        // Submit all light items
        await createLighting(token, currentEnvironment.id, lightsData);
        history.goBack();
      } catch (error) {
        // @ts-expect-error
        setError(error.response.data.error as ErrorResponse);
      }
    } else {
      setError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  const handleAdd = () => {
    setLightsData((prevLights) => [...prevLights, { ...emptyLightDetail }]);
  };

  const handleLightUpdate = (
    updatedLight: LightDetailItem,
    position: number
  ) => {
    if (lightsData?.length) {
      const updatedLightsData = [...lightsData];
      updatedLightsData.splice(position, 1, updatedLight);
      setLightsData(updatedLightsData);
    }
  };

  const handleLightDelete = (position: number) => {
    const updatedBlockData = [...lightsData];
    updatedBlockData.splice(position, 1);
    setLightsData(updatedBlockData);
  };

  return (
    <PageStandard title="Iluminação" onAdd={handleAdd}>
      <BlockStandard hideDivider>
        <DetailedSelector />
      </BlockStandard>

      {!!lightsData?.length &&
        lightsData.map((item, position) => {
          return (
            <LightDetail
              key={position}
              lightData={item}
              itemPos={position}
              lampOptions={lampOptions}
              onChange={(updatedLight) => {
                handleLightUpdate(updatedLight, position);
              }}
              onDelete={() => handleLightDelete(position)}
            />
          );
        })}

      {!!lightsData?.length && (
        <Button variant="contained" onClick={handleSubmit}>
          Atualizar dados de iluminação
        </Button>
      )}
    </PageStandard>
  );
};
